module.exports = __webpack_public_path__ + "static/background-image-44d2431b206e3a2e38170ae1b16052e0.jpg";